import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";

export const CreateUserWalletWithDrawService=async(data)=>{
    try {
        const result = await post(`api/user_waller_withdraw/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateUserWalletWithDrawService=async(data,id)=>{
    try {
        const result = await put(`api/user_waller_withdraw/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetUserWalletWithDrawService=async(page,from_date,to_date,step,user)=>{
    try {
        const result = await get(`api/user_waller_withdraw/get?page=${page}&from_date=${from_date}&to_date=${to_date}&step=${step}&user=${user}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteUserWalletWithDrawService=async(id)=>{
    try {
        const result = await deleteRequest(`api/user_waller_withdraw/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const UploadUserWalletWithDrawService=async(data)=>{
    try {
        const result = await postfd(`api/user_waller_withdraw/upload_file`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}